import { RouteConfig } from "vue-router";
import Layout from '@/layout/index.vue';

const setting: RouteConfig[] = [
  {
    path: '/setting',
    component: Layout,
    meta: {
      roles: ['permission']
    },
    children: [
      {
        path: 'setting',
        name: 'setting',
        meta: {
          icon: 'company-setting-icon',
          title: 'setting',
          roles: ['permission']
        },
        component: () => import(/* webpackChunkName: "setting" */ '@/views/company-setting/CompanySetting.vue'),
      },
      {
        path: 'add-contact-person/:id',
        name: 'contactPerson',
        meta: {
          hidden: true,
          activeMenu: '/setting/setting',
          title: 'contactPerson',
          roles: ['permission']
        },
        component: () => import(/* webpackChunkName: "company-setting" */ '@/views/company-setting/AddContactPerson.vue'),
      },
    ]
  }
]
export default setting
